import { Skeleton } from 'antd';
import React from 'react';

interface Props {
  isLoading?: boolean;
  children?: JSX.Element | string;
}

export const ThreadDataSkeleton: React.FC<Props> = (props: Props) => {
  const { isLoading, children } = props;

  const attrs = {
    wrapper: { className: 'thread-data' },
    header: { className: 'thread-data__header' },
    body: {
      wrapper: { className: 'thread-data__body' },
      leftSection: {
        wrapper: { className: 'thread-data__body__left-section' },
      },
      divider: { className: 'thread-data__body__divider' },
      rightSection: {
        wrapper: { className: 'thread-data__body__right-section' },
      },
    },
    skeletons: {
      header: {
        loading: isLoading,
        active: true,
        avatar: false,
        paragraph: false,
        title: {
          style: {
            width: 82,
            maxWidth: '100%',
            height: 13,
            borderRadius: 2,
            marginTop: 2,
          },
        },
      },
      sectionHeading: {
        loading: isLoading,
        active: true,
        avatar: false,
        paragraph: false,
      },
      centralValue: {
        loading: isLoading,
        active: true,
        avatar: false,
        paragraph: false,
        title: {
          style: {
            width: 70,
            height: 11,
            borderRadius: 2,
            margin: 'auto',
            marginTop: 12,
            marginBottom: 1,
          },
        },
      },
    },
  };

  const sectionHeaderSkeleton = (
    width: string,
    marginTop?: string,
    height?: string
  ) => {
    return (
      <div>
        <Skeleton
          {...attrs.skeletons.sectionHeading}
          title={{
            style: {
              width,
              height: height || 12,
              borderRadius: 2,
              marginTop: marginTop || 0,
            },
          }}
        />
      </div>
    );
  };

  const centralValueSkeleton = <Skeleton {...attrs.skeletons.centralValue} />;

  return (
    <>
      {isLoading ? (
        <div {...attrs.wrapper}>
          <div {...attrs.header}>
            <div>
              <Skeleton {...attrs.skeletons.header} />
            </div>
          </div>
          <div {...attrs.body.wrapper}>
            <div {...attrs.body.leftSection.wrapper}>
              {sectionHeaderSkeleton('40%')}
              {centralValueSkeleton}
              {sectionHeaderSkeleton('55%', '40px')}
              {sectionHeaderSkeleton('45%', '6px', '11px')}
              {sectionHeaderSkeleton('55%', '8px', '11px')}
            </div>
            <div {...attrs.body.divider} />
            <div {...attrs.body.rightSection.wrapper}>
              {sectionHeaderSkeleton('100%')}
              {centralValueSkeleton}
              {sectionHeaderSkeleton('65%', '40px')}
              {sectionHeaderSkeleton('68%', '6px', '11px')}
              {sectionHeaderSkeleton('40%', '8px', '11px')}
            </div>
          </div>
        </div>
      ) : (
        children
      )}
    </>
  );
};
